import ControlFactory from '@/Factories/ControlFactory';
import ComponentManager from '@/Management/ComponentManager';
import MultiSelectDropDownListViewModelType from '@/ViewModels/Controls/MultiSelectDropDownListViewModel';
import MultiSelectDropDownListType from '@/Controls/MultiSelectDropDownList';
import LabelViewModelType from '@/ViewModels/Controls/LabelViewModel';

export default class MultiSelectDropDownListFactory extends ControlFactory {

    private jQueryControl: JQuery;
    private MultiSelectDropDownListViewModel = ComponentManager.getViewModel<typeof MultiSelectDropDownListViewModelType>('MultiSelectDropDownListViewModel');
    private MultiSelectDropDownList = ComponentManager.getControl<typeof MultiSelectDropDownListType>('MultiSelectDropDownList');
    protected LabelViewModel = ComponentManager.getViewModel<typeof LabelViewModelType>('LabelViewModel');

    public constructor(params: any) {
        super(params);
    }

    /**
     * @override
     */
    control: MultiSelectDropDownListType;
    /**
     * @override
     */
    viewModel: MultiSelectDropDownListViewModelType;


    /**
     * @override
     */
    public getControl(): JQuery {
        if (this.jQueryControl != null) {
            return this.jQueryControl;
        }

        if (!this.viewModel) {
            this.viewModel = this.detailViewItem.viewModel || this.createViewModel(this.createViewModelParameter());
        }

        this.control = new this.MultiSelectDropDownList(this.viewModel);

        let tuple = this.control.getTuple();
        this.jQueryControl = tuple.control;

        this.addOverwritableToControl(this.jQueryControl, [this.detailViewItem.name]);
        this.registerDefaultValidation([this.detailViewItem.name]);

        return this.jQueryControl;
    }

    protected createViewModel(params: any): MultiSelectDropDownListViewModelType {
        return new this.MultiSelectDropDownListViewModel(params);
    }

    protected createViewModelParameter(): any {
        return {
            factory: self,
            isRequired: this.isRequired,
            isEnabled: this.isEnabled,
            isValid: this.isValid,
            isFocusable: this.isFocusable,
            invalidationText: this.invalidationText,
            data: this.getData(),
            dataValueField: this.getDataValueField(),
            dataTextField: this.getDataTextField(),
            values: this.getValues(),
            tooltip: new this.LabelViewModel({
                ergName: this.detailViewItem.tooltip
            }),
            parentLocator: this.locator,
            locator: this.detailViewItem.name,
            onOpen: this.onOpen.bind(this),
            onClose: this.onClose.bind(this),
            onAdded: this.onAdded.bind(this),
            onRemoved: this.onRemoved.bind(this)
        };
    }

    /**
    * Wird ausgeführt, wenn das Dropdown geöffnet wird
    */
    protected onOpen(): void {

    }

    /**
    * Wird ausgeführt, wenn das Dropdown geschlossen wird
    */
    protected onClose(): void {

    }

    /**
     * Wird ausgeführt, wenn ein Objekt angehakt wird
     */
    protected onAdded(added: any): void {

    }

    /**
     * Wird ausgeführt, wenn ein Objekt abgehakt wird
     */
    protected onRemoved(removed: any): void {

    }

    /**
    * Liefert ein Observable, in dem sich die verfügbaren Einträge befinden
    */
    protected getData(): KnockoutAsyncComputed<any> | KnockoutComputed<any> | KnockoutObservableArray<any> | KnockoutObservable<any> {
        return this.context.genericObject.getObservable(this.detailViewItem.name + '.Data', []);
    }

    /**
    * Liefert den Namen des Feldes, in dem sich der Wert eines Eintrags befinden
    */
    protected getDataValueField(): string {
        return null;
    }

    /**
    * Liefert den Namen des Feldes, in dem sich der Bezeichner eines Eintrags befinden
    */
    protected getDataTextField(): string {
        return null;
    }

    /**
    * Liefert ein Observable, in dem sich der aktuelle Wert befindet
    */
    protected getValues(): KnockoutAsyncComputed<any> | KnockoutComputed<any> | KnockoutObservableArray<any> | KnockoutObservable<any> {
        return this.context.genericObject.getObservable(this.detailViewItem.name);
    }

}

ComponentManager.setFactory('MultiSelectDropDownList', MultiSelectDropDownListFactory, 'RADPresentation.HTMLClient.DefaultViewExtensions');